<!--
* UIID: UI-DLB-ID-100
* UI Name: Users
* Modify Date: 2020/06/18
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.users.page_header') }}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- /**
          * 2021.08.02 203737 SPKA-170 issue 110 Change all text field and combo box style for search condition [Administrator]
          */ -->
    <!-- Condition search -->
    <v-row class="custom-form-control custom-figma-1 mb-0">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
            lg="7"
            md="7"
          >
            <v-row>
              <v-col cols="12" lg="3" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="srcUsrId"
                  @keyup.enter="searchData"
                  :label="$t('lbl.common.conditionSearch.findbyUserID')"
                  dense
                  filled
                  class="custom-selectbox"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="srcUsrNm"
                  @keyup.enter="searchData"
                  :label="$t('lbl.common.conditionSearch.findbyUserName')"
                  class="custom-selectbox"
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="srcCompId"
                  @change="searchData"
                  :items="compList"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectCompany')"
                  class="custom-selectbox"
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="3" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="srcUseGrdCd"
                  :items="roleList"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectRole')"
                  @change="searchData"
                  class="custom-selectbox"
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right"
            cols="12"
            lg="5"
            md="5"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control"></div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn class="btn btn-top btn-search btn-width-1" color="primary" @click="searchData">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Button Action -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  @click="openAddUserWindow(null, 'Add')"
                  :disabled="!$auth.manage"
                  class="btn btn-add"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"> </v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="40"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Grid table List -->
    <v-row>
      <!-- // 2021.5.19 203728 Issue 53 No display spinner -->
      <!-- 2021.12.8 203728 SPKA-305 show bottom border -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :footer-props="{
            showFirstLastPage: true,
          }"
          :search="searchByTxt"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          hide-default-footer
          :sort-desc="true"
          sort-by="updDt"
          :class="[
            'list-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                @click="onClickRow(item)"
                :class="[selectedRow === item.id ? 'selected_row' : '']"
              >
                <td>
                  <font class="col-id">{{ item.usrId }}</font>
                </td>
                <td>{{ item.usrNm }}</td>
                <td>{{ item.compNm }}</td>
                <td>{{ item.compTelNo }}</td>
                <td class="text-center">
                  <font :class="viewRoleTextColor(item.useGrdCd)">{{
                    viewRole(item.useGrdCd)
                  }}</font>
                </td>
                <td class="text-center">
                  <font :class="viewStatusTextColor(item.authCd)">{{
                    viewStatus(item.authCd)
                  }}</font>
                </td>
                <td class="text-center">{{ item.updDt }}</td>
                <td class="text-center">
                  <v-btn
                    small
                    text
                    icon
                    @click="openAddUserWindow(item, 'Edit')"
                    :disabled="!$auth.manage"
                  >
                    <icon-svg :disabled="!$auth.manage" iconName="edit" />
                  </v-btn>
                  <v-btn small text icon @click="onDelteUser(item)" :disabled="!$auth.manage">
                    <icon-svg :disabled="!$auth.manage" iconName="delete" />
                  </v-btn>
                  <!-- 2단계 인증(OTP) 초기화 / 잠금 해제 -->
                  <v-btn
                    small
                    text
                    icon
                    :title="$t('msg.otp.adminTitle')"
                    @click.stop="$refs.otpAdminDialog.open(item)"
                    :disabled="!$auth.manage"
                  >
                    <v-icon x-small>fa fa-shield-alt</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <dialogWindow
      ref="addUserDialog"
      size="max"
      :info="checkDialogTitle"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    ></dialogWindow>
    <!-- // 2021.12.1 SPKA-297 svg icon -->
    <dialogWindow
      ref="deleteDialog"
      :info="deleteUser.usrNm"
      size="max"
      title="Delete Communication"
      :detail="$t('msg.users.clickIconDelete')"
      color="confirmation"
      :showCancel="true"
      @select-ok="deleteItem(deleteUser)"
    ></dialogWindow>
    <otp-admin-dialog ref="otpAdminDialog"></otp-admin-dialog>
    <!-- 2021.11.25 213960 change page function position, change v-pagination to custom pagination, add button first last -->
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }} of
                    {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import $ from 'jquery';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
// 2021.12.1 SPKA-297 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { openWindow } from '@/vue-dlb/utils/window-opener';
import OtpAdminDialog from '@/vue-caas/views/user/OtpAdminDialog.vue';

export default {
  components: {
    dialogWindow,
    SystemProgress,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
    OtpAdminDialog,
  },
  props: {
    items: {
      default: Array,
    },
  },

  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      searchBy: '',
      searchByTxt: '',
      srcUsrId: '',
      srcUsrNm: '',
      srcCompId: null,
      srcUseGrdCd: null,
      headers: [],
      listData: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialogs: [],
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      checkDialogTitle: 'Alert',
      isCreated: false,
      tableHeight: '',
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      compList: [],
      compOrgList: [],
      roleList: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'Monitoring User', value: 1 },
        { text: 'General User', value: 2 },
        { text: 'Administrator', value: 3 },
      ],
      userViewArr: [],
      // 2021.5.19 203728 Issue 53
      isLoading: false,
      totalCnt: 0,
      pageEnter: 1,
      // 2021.12.1 SPKA-297 svg icon
      deleteUser: {
        usrNm: '',
      },
      selectedRow: '',
    };
  },

  computed: {
    ...mapState('common', {
      repomenuMode: 'repomenuMode',
      sysloadingTitle: 'sysloadingTitle',
    }),
  },

  watch: {
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
  },

  created() {
    this.headers = [
      { text: 'User ID', value: 'usrId', 'min-width': '360px' },
      { text: 'User Name', value: 'usrNm', width: '200px' },
      { text: 'Company', value: 'compNm', width: '230px' },
      { text: 'Phone', value: 'compTelNo', width: '200px' },
      { text: 'Role', value: 'useGrdCd', align: 'center', width: '200px' },
      { text: 'Email Status', value: 'authCd', align: 'center', width: '250px' },
      { text: 'Last Update', value: 'updDt', align: 'center', width: '160px' },
      { text: 'Manage', value: 'manage', align: 'center', 'min-width': '70px' }, //2021-04-20: 163189 Fixing broken column manager because version.
    ];
    const params = [];

    this.$store.dispatch('getCompanyMngList', params).then(() => {
      this.compOrgList = this.$store.getters.apicompanies;
      this.compList.push({ text: this.$t('lbl.common.conditionSearch.all'), value: '' });
      for (let i = 0; i < this.compOrgList.length; i += 1) {
        const comp = this.compOrgList[i];
        this.compList.push({
          name: `${comp.compNm}`,
          text: `${comp.compNm} (${comp.compId})`,
          value: `${comp.compId}`,
        });
      }

      this.roleList = [];
      this.roleList.push({ text: this.$t('lbl.common.conditionSearch.all'), value: '' });

      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C02' }).then(() => {
        const roles = this.$store.getters['caascommon/comCdList'];
        for (let i = 0; i < roles.length; i += 1) {
          this.roleList.push({ text: roles[i].cdNm, value: roles[i].comCd });
        }
        this.searchData();
      });
    });
    this.isCreated = true;
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {},

  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    onClickRow(item) {
      this.selectedRow = item.id;
    },
    // 2021.12.1 SPKA-297 svg icon
    onDelteUser(item) {
      this.deleteUser = item;
      this.$refs.deleteDialog.dialog = true;
    },
    searchData() {
      // 2021.5.19 203728 Issue 53
      this.isLoading = true;
      const params = {
        srcUsrId: this.srcUsrId,
        srcUsrNm: this.srcUsrNm,
        srcCompId: this.srcCompId,
        srcUseGrdCd: this.srcUseGrdCd,
      };

      this.$store
        .dispatch('getUserList', params)
        .then(() => {
          this.listData = this.$store.getters.userList.map((item) => {
            const company = this.compOrgList.find((c) => c.compId === item.compId);
            return {
              ...item,
              compNm: company ? company.compNm : '',
            };
          });
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
          this.page = 1;
          // 2021.5.19 203728 Issue 53
          this.isLoading = false;
        })
        .catch((ex) => {
          // 2021.5.19 203728 Issue 53
          this.isLoading = false;
        });
    },
    deleteItem(item) {
      this.$store.dispatch('deleteUsr', item).then(() => {
        this.$refs.addUserDialog.dialog = true;
        this.checkDialogColor = 'success';
        this.checkDialogInfo = `Removed user (${item.usrId}) successfully.`;
        this.checkDialogTitle = 'Removed Success';
        this.searchData();
      });
    },

    closeDialog() {
      this.$refs.addUserDialog.dialog = false;
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    //Open New Window AddUser
    openAddUserWindow(item, type) {
      let isEdit = false;
      let params = {};
      if (type === 'Edit') {
        isEdit = true;
        params = {
          ROWID: item.id.toString(),
          indexType: 1,
          paramItem: Object.assign({}, item),
          options: {
            id: item.id.toString(),
            isEdit: isEdit,
          },
        };
      } else {
        item = { id: '0' };
        params = {
          ROWID: '0',
          indexType: -1,
          paramItem: {},
          options: {
            id: '0',
            isEdit: isEdit,
          },
        };
      }
      const arrView = {
        item,
        type,
      };
      const url = `/users/userDetail/${params.ROWID}`;
      const size = `width=1100,height=794,left=100,top=30`;
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
        onClose: () => {
          this.searchData();
        },
      });
    },
    viewStatus(stsCd) {
      let result = '';
      if (stsCd === 'C') {
        result = 'Confirmed';
      } else if (stsCd === 'W') {
        result = 'Waiting Confirmation';
      } else if (stsCd === 'N') {
        result = 'Not Send Email';
      } else if (stsCd === 'A') {
        result = 'Approved';
      }
      return result;
    },

    viewStatusTextColor(stsCd) {
      let result = '';
      if (stsCd === 'C') {
        result = 'confirm--text text--lighten-2';
      } else if (stsCd === 'W') {
        result = 'waiting--text text--lighten-2';
      } else if (stsCd === 'N') {
        result = 'notsend--text text--lighten-2';
      } else if (stsCd === 'A') {
        result = 'confirm--text text--lighten-2';
      }
      return result;
    },

    viewRole(stsCd) {
      let result = '';
      for (let i = 0; i < this.roleList.length; i += 1) {
        const role = this.roleList[i];
        if (stsCd === role.value) {
          result = role.text;
          break;
        }
      }
      return result;
    },

    viewRoleTextColor(stsCd) {
      let result = '';
      if (stsCd === '3') {
        result = 'confirm--text text--lighten-2';
      } else if (stsCd === '2') {
        result = 'waiting--text text--lighten-2';
      } else if (stsCd === '1') {
        result = 'notsend--text text--lighten-2';
      } else if (stsCd === '9') {
        result = 'col-id';
      }
      return result;
    },
    // 2021.11.25 213960 modify page function: change page and change page size
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },
};
</script>

<style scoped>
.user-dialog {
  width: 1100px !important;
}
</style>
